import React, { useEffect, useRef } from "react";

import Navbar from "./components/Navbar";
import CardTechnology from "./components/cardTechnology";
import CardDepositions from "./components/cardDepositions";
import DepositionsCarousel from "./components/cardDepositions/depositionCarousel.jsx";
import CardProject from "./components/cardProject/index.jsx";
import ContactForm from "./components/contactForm";
import Loading from "./components/loading/index.jsx";
import LogoLoop from "./components/logoLoop/index.jsx";
import { projects } from "./data/projects";

import photoMe01 from "./img/photo/ft01.png";
import photoMe02 from "./img/photo/ft02.png";
import photoMe03 from "./img/photo/ft03.png";
import photoMe04 from "./img/photo/ft04.png";
import photoMe05 from "./img/photo/ft05.png";
import photoMe06 from "./img/photo/ft06.png";
import photoMe07 from "./img/photo/ft07.png";

import linkedin from "../src/img/icon/social-linkedin.svg";
import instagram from "../src/img/icon/social-instagram.svg";
import gitHub from "../src/img/icon/social-gitHub.svg";

import html from "./img/tech/lg-html.svg";
import css from "./img/tech/lg-css.svg";
import js from "./img/tech/lg-js.svg";
import jquery from "./img/tech/lg-jquery.svg";
import react from "./img/tech/lg-react.svg";
import php from "./img/tech/lg-php.svg";
import sass from "./img/tech/lg-sass.png";
import blender from "./img/tech/lg-blender.svg";
import figma from "./img/tech/lg-figma.svg";
import ps from "./img/tech/lg-ps.svg";
import fluig from "./img/tech/lg-fluig.png";
import sql from "../src/img/tech/lg-sql.png";
import mysql from "../src/img/tech/lg-mysql.png";
import bootstrap from "../src/img/tech/lg-bootstrap.png";
import ai from "../src/img/tech/lg-ai.png";
import github2 from "../src/img/tech/lg-github.svg";
import postman from "../src/img/tech/lg-postman.svg";
import laravel from "../src/img/tech/lg-laravel.png";

import lightRight from "../src/img/others/lightRight.svg";
import lightLeft from "../src/img/others/lightLeft.svg";
import bkgSectionForm from "../src/img/others/bkgSection.svg";

const grayLogosCtx = require.context(
  "./img/tech",
  false,
  /^\.\/lg-gray-(?!bootstrap-1).*\.svg$/
);
const grayLogos = grayLogosCtx.keys().map((key) => ({
  src: grayLogosCtx(key),
  alt: key.replace("./lg-gray-", "").replace(".svg", ""),
}));

function App() {
  useEffect(() => {
    const animationSection = () => {
      const sections = document.querySelectorAll(".sectionAnimate");
      sections.forEach((section) => {
        const windowHeight = window.innerHeight;
        const sectionTop = section.getBoundingClientRect().top;
        const animationPoint = 100;

        if (sectionTop < windowHeight - animationPoint) {
          section.classList.add("active");
        } else {
          section.classList.remove("active");
        }
      });
    };

    window.addEventListener("scroll", animationSection);

    return () => {
      window.removeEventListener("scroll", animationSection);
    };
  }, []);

  const containerRef = useRef(null);
  const handleScroll = (direction) => {
    const container = containerRef.current;
    if (container) {
      const scrollAmount = direction === "next" ? -300 : 300;
      container.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const query = new URLSearchParams(window.location.search);
  const getCategory = query.get("category");
  var type = getCategory === "w" || getCategory == null ? "w" : "fluig";

  const textContent = {
    fluig: {
      cv: {
        href: "/Currículo - Lucas Da Silva Lima - Desenvolvedor Fluig.pdf",
        download: "Currículo - Lucas Da Silva Lima - Desenvolvedor Fluig",
      },
      home: "Desenvolvo processos no Totvs Fluig alinhando regras de negócio à melhor experiência do usuário. Cada etapa é pensada para otimizar rotinas e reduzir erros. Meu objetivo é criar layouts claros e atrativos, tornando a navegação intuitiva e o uso mais eficiente.",
      aboutMe: [
        "Sou desenvolvedor web fullstack e UI designer, natural de Cuiabá - MT, especializado na criação de soluções digitais que unem design intuitivo e sistemas funcionais. Apesar de atuar com diferentes linguagens de programação, concentro meu foco no desenvolvimento de processos e customizações no Fluig, garantindo resultados que realmente fazem sentido para o usuário e para o negócio.",
        " Do levantamento de requisitos à entrega final, trabalho com visão completa, cuidando de cada detalhe para transformar ideias em processos eficientes e fáceis de usar. Um exemplo disso é a Central de Aprovações, solução que ajudei a criar integrando o Fluig ao Protheus via API REST, permitindo a centralização de processos como pedidos de compras, solicitações de armazém e medições de contrato, tornando os fluxos mais ágeis e organizados.",
        "Sou reconhecido por meu olhar apurado para design, aprendizado rápido e dedicação em cada projeto. Busco constantemente aperfeiçoar minhas habilidades, motivado por desafios e pela vontade de ir além, sempre em busca de soluções criativas e eficientes.",
      ],
      subtitleHab:
        "Essas são as habilidades que possuo e venho aprimorando ao longo da minha jornada como desenvolvedor Fluig",
      habilidades: {
        1: {
          title: "BPMN & Automação de Processos",
          content:
            "Tenho experiência na criação de fluxos BPMN no Fluig, buscando sempre processos claros e funcionais.",
        },
        2: {
          title: "ECM & WCM",
          content:
            "Atuo com o ECM do Fluig estruturando documentos, permissões e pastas, sempre com foco em organização e controle. Já no WCM, desenvolvo conteúdos que tornam o portal mais atrativo e funcional, criando experiências acessíveis para os usuários.",
        },
        3: {
          title: "Integrações",
          content:
            "Participo de integrações entre Fluig e ERPs TOTVS, como Protheus e RM. Utilizo APIs REST e Web Services SOAP para conectar processos e garantir que as informações fluam corretamente entre os sistemas, otimizando a rotina das equipes.",
        },
        4: {
          title: "ERP’s",
          content:
            "Tenho contato com os ERPs Protheus e RM, principalmente em cenários que envolvem integração com o Fluig.",
        },
      },
      position: "Desenvolvedor Totvs Fluig",
      aboutMeQuote: [
        "Especialista em Fluig com visão completa do processo — do levantamento ao deploy. Combino ",
        "automação e design",
        " para criar soluções que realmente funcionam no dia a dia dos colaboradores.",
      ],
      bullets: [
        {
          label: "Processos BPMN:",
          text: "criação de fluxos eficientes no Fluig, do levantamento à entrega.",
        },
        {
          label: "Integrações:",
          text: "APIs REST e Web Services SOAP conectando Fluig a ERPs TOTVS.",
        },
        {
          label: "UI & UX:",
          text: "portais e interfaces que tornam o Fluig mais atrativo e funcional.",
        },
        {
          label: "Visão fullstack:",
          text: "do processo ao produto — HTML, CSS, JS, PHP e customizações TOTVS.",
        },
      ],
      academic: [
        {
          title: "Bacharelado em Sistemas de Informação",
          subtitle: "Graduação · Cuiabá, MT",
        },
        {
          title: "Pós-graduação em Desenvolvimento Full Stack",
          subtitle: "FIAP · Previsão de conclusão: janeiro de 2027",
          badge: "Em andamento",
        },
        {
          title: "Inglês",
          subtitle: "Influx · Curso em andamento",
          badge: "Em andamento",
        },
      ],
      experience: [
        {
          title: "Desenvolvedor Fluig",
          subtitle: "Full-time · 2022 — presente",
        },
        {
          title: "Integrações Protheus & RM TOTVS",
          subtitle: "Desenvolvimento de integrações · 2021 — presente",
        },
        {
          title: "Desenvolvimento React & Laravel",
          subtitle: "Fullstack · 2020 — presente",
        },
      ],
    },
    w: {
      cv: { href: "/cv.pdf", download: "Currículo - Lucas da Silva Lima.pdf" },
      home: "Desenvolvimento Fluig, integrações TOTVS e interfaces modernas. Do processo ao produto — do problema à solução.",
      aboutMe: [
        "Sou desenvolvedor com experiência em diferentes etapas de um projeto, desde a conversa inicial com o cliente, levantamento de requisitos, prototipagem, até a implementação e entrega final. Tenho domínio em PHP, jQuery, SQL Server, HTML, CSS, JavaScript, além de bastante afinidade com design e usabilidade, utilizando ferramentas como Figma, Photoshop e Blender.",
        "Tenho muito interesse em todas as partes do desenvolvimento, porque acredito que entender o processo como um todo é o que garante soluções mais completas e eficazes. Procuro sempre ser comunicativo e claro nas minhas interações, transmitindo ideias de forma objetiva e sabendo adaptar a conversa para que todos — tanto técnicos quanto não técnicos — entendam o que está sendo proposto.",
        "Sou curioso, gosto de aprender constantemente e de unir a parte lógica com a parte visual, equilibrando técnica e criatividade. Meu objetivo é seguir evoluindo como desenvolvedor, aprofundando meus conhecimentos em desenvolvimento web e gerenciamento de projetos, além de abrir espaço para novos desafios no futuro.",
      ],
      subtitleHab:
        "Essas são as habilidades que possuo e venho aprimorando ao longo da minha jornada como desenvolvedor web",
      habilidades: {
        1: {
          title: "Front-end",
          content:
            "Sou motivado pela construção de interfaces, com atenção aos detalhes visuais e foco em usabilidade, buscando sempre o equilíbrio entre estética e funcionalidade",
        },
        2: {
          title: "UI & UX",
          content:
            "Tenho um cuidado especial com a forma como o usuário interage com a interface, buscando sempre entregar experiências intuitivas e acessíveis. Acredito que uma boa interface deve ser para todos, por isso me preocupo em atender requisitos de acessibilidade desde o início do processo",
        },
        3: {
          title: "Fluig",
          content:
            "No meu trabalho atual, venho aprimorando minhas habilidades com o Fluig, buscando aplicar não só o que sei da ferramenta, mas também outras competências que desenvolvo ao longo da carreira. Sempre procuro pensar fora da caixa para criar processos eficientes e que realmente façam a diferença no dia a dia dos integrantes",
        },
        4: {
          title: "Back-end",
          content:
            "Atuo com desenvolvimento back-end utilizando PHP e o framework Laravel, buscando escrever código limpo, seguro e escalável. Tenho me dedicado a aprender cada vez mais, estudando arquitetura de software, APIs RESTful, autenticação, e boas práticas.",
        },
      },
      position: "Desenvolvedor web",
      aboutMeQuote: [
        "Desenvolvedor com experiência em todas as etapas de um projeto — da conversa com o cliente até a entrega final. Combino ",
        "técnica e criatividade",
        " para construir soluções que funcionem e que as pessoas realmente consigam utilizar.",
      ],
      bullets: [
        {
          label: "Full-cycle:",
          text: "levantamento de requisitos, prototipagem, implementação e entrega — sem gaps no processo.",
        },
        {
          label: "Comunicação clara:",
          text: "traduzo o técnico para o não-técnico e vice-versa, mantendo todo mundo na mesma página.",
        },
        {
          label: "Visão completa:",
          text: "PHP, JavaScript, SQL, HTML, CSS, Figma — e domínio em Fluig, Protheus e RM TOTVS.",
        },
        {
          label: "Sempre evoluindo:",
          text: "curioso por natureza, focado em aprofundar desenvolvimento web, UX e gestão de projetos.",
        },
      ],
      academic: [
        {
          title: "Bacharelado em Sistemas de Informação",
          subtitle: "Graduação · Cuiabá, MT",
        },
        {
          title: "Pós-graduação em Desenvolvimento Full Stack",
          subtitle: "FIAP · Previsão de conclusão: janeiro de 2027",
          badge: "Em andamento",
        },
        {
          title: "Inglês",
          subtitle: "Influx · Curso em andamento",
          badge: "Em andamento",
        },
      ],
      experience: [
        {
          title: "Desenvolvedor Fluig",
          subtitle: "Full-time · 2022 — presente",
        },
        {
          title: "Desenvolvedor AR - Meta",
          subtitle: "Desenvolvimento de filtros para o Instagram · 2019 — 2021",
        },
      ],
    },
  };

  return (
    <div className="container">
      <span className="spanResponsive"></span>
      <Loading />
      <Navbar />
      <nav className="hiddenNavBarMobile-2 navBarMobile-menu d-flex-row">
        <button className="buttonNavBarMobile" id="btnOppenNav">
          <span className="material-symbols-outlined menu">menu</span>
        </button>
      </nav>
      <section className="sectionPage" id="home">
        <section className="sectionHome d-flex-column center">
          <div className="backgroundHome">
            <div className="bgGrid"></div>
            <div className="bgGlow"></div>
          </div>
          <p className="text-olaSou">Olá, meu nome é</p>
          <h2 class="text-myName">Lucas</h2>
          <h1 className="paragraph text-descMe">{textContent[type].home}</h1>
          <section
            className="sectionHomeButtons d-flex-row"
            id="sectionHomeButtons"
          ></section>
        </section>
        <span className="loader"></span>
      </section>
      <LogoLoop
        logos={grayLogos}
        speed={30}
        logoHeight={40}
        gap={90}
        pauseOnHover
        fadeOut
        scaleOnHover
      />
      <section className="d-flex-row sectionAboutMe" id="sectionAboutMe">
        <div className="containerBkgPhotoMe">
          <div className="bkgPhotoMe d-flex-row sectionAnimate">
            <img src={photoMe01} alt="" className="mePhoto"></img>
            <img src={photoMe02} alt="" className="mePhoto"></img>
            <img src={photoMe03} alt="" className="mePhoto"></img>
            <img src={photoMe04} alt="" className="mePhoto"></img>
            <img src={photoMe06} alt="" className="mePhoto"></img>
            <img src={photoMe05} alt="" className="mePhoto"></img>
            <img src={photoMe07} alt="" className="mePhoto"></img>
          </div>
        </div>

        <div className="containerContentAboutMe d-flex-column sectionAnimate">
          <div className="d-flex-column titleSection sectionAnimate">
            <h1 className="lt-50">Sobre</h1>
            <small className="paragraph">
              Essas são as tecnologias que domino e utilizo no desenvolvimento
              web
            </small>
          </div>
          <div className="aboutMe-layout">
            <div className="aboutMe-left">
              <p className="aboutMe-quote">
                {textContent[type].aboutMeQuote[0]}
                <strong>{textContent[type].aboutMeQuote[1]}</strong>
                {textContent[type].aboutMeQuote[2]}
              </p>
              <ul className="aboutMe-bullets">
                {textContent[type].bullets.map((item, i) => (
                  <li key={i}>
                    <strong>{item.label}</strong> {item.text}
                  </li>
                ))}
              </ul>
            </div>
            <div className="aboutMe-right">
              <div>
                <h3 className="aboutMe-section-title">Formação Acadêmica</h3>
                {textContent[type].academic.map((item, i) => (
                  <div key={i} className="aboutMe-item">
                    <span className="aboutMe-item-title">{item.title}</span>
                    <span className="aboutMe-item-subtitle">
                      {item.subtitle}
                    </span>
                    {item.badge && (
                      <span className="aboutMe-badge">{item.badge}</span>
                    )}
                  </div>
                ))}
              </div>
              <div>
                <h3 className="aboutMe-section-title">
                  Experiência Profissional
                </h3>
                {textContent[type].experience.map((item, i) => (
                  <div key={i} className="aboutMe-item">
                    <span className="aboutMe-item-title">{item.title}</span>
                    <span className="aboutMe-item-subtitle">
                      {item.subtitle}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <img
          alt=""
          src={lightLeft}
          className="lightLeft lightLeftAboutMe"
        ></img>
      </section>

      <section className="sectionPage d-flex-column" id="sectionTechnology">
        <div className="d-flex-column titleSection sectionAnimate">
          <h1 className="lt-50">Tecnologias</h1>
          <small className="paragraph">
            Essas são as tecnologias que domino e utilizo no desenvolvimento web
          </small>
        </div>
        <div className="containerCardsTech d-flex-row sectionAnimate">
          <button
            className="btnNavCardTach"
            id="buttonBackCardTech"
            onClick={() => handleScroll("next")}
          >
            <span className="material-symbols-outlined">arrow_forward_ios</span>
          </button>
          <div
            className="containerCardsTech-content"
            id="containerCardsTechContent"
            ref={containerRef}
          >
            <CardTechnology
              study="false"
              tool="true"
              pathImage={fluig}
              name="Fluig"
              description="Automatiza processos e gerencia conteúdo corporativo"
            />
            <CardTechnology
              study="true"
              pathImage={react}
              name="React"
              description="Cria interfaces de usuário interativas"
            />{" "}
            <CardTechnology
              study="true"
              pathImage={laravel}
              name="Laravel"
              description="Framework PHP utilizado para devenvolvimento MVC "
            />
            <CardTechnology
              study="false"
              tool="true"
              pathImage={postman}
              name="Postman"
              description="Plataforma usada para desenvolver e testar APIs"
            />{" "}
            <CardTechnology
              study="false"
              pathImage={github2}
              name="GitHub"
              description="Plataforma de hospedagem de código e controle de versão"
            />
            <CardTechnology
              study="false"
              pathImage={php}
              name="Php"
              description="Usado para desenvolvimento web no lado servidor"
            />{" "}
            <CardTechnology
              study="false"
              pathImage={jquery}
              name="Jquery"
              description="Simplifica manipulação de DOM, eventos e AJAX"
            />
            <CardTechnology
              study="false"
              pathImage={html}
              name="Html"
              description="Estrutura o conteúdo das páginas web com textos, links e imagens"
            />
            <CardTechnology
              study="false"
              pathImage={css}
              name="Css"
              description="Estiliza páginas, controlando cores, fontes e layouts"
            />
            <CardTechnology
              study="false"
              pathImage={js}
              name="Java Script"
              description="Torna páginas web interativas e dinâmicas"
            />
            <CardTechnology
              study="false"
              pathImage={sass}
              name="Sass"
              description="Pré-processador CSS com recursos como variáveis e funções"
            />
            <CardTechnology
              study="false"
              pathImage={bootstrap}
              name="Boostrap"
              description="Framework CSS para desenvolvimento responsivo e rápido"
            />
            <CardTechnology
              study="false"
              pathImage={sql}
              name="SQL"
              description="Usado para gerenciar bancos de dados relacionais"
            />{" "}
            <CardTechnology
              study="false"
              pathImage={mysql}
              name="MySql"
              description="Usado para gerenciar bancos de dados relacionais"
            />
            <CardTechnology
              study="false"
              tool="true"
              pathImage={figma}
              name="Figma"
              description="Ferramenta de design colaborativo para interfaces"
            />
            <CardTechnology
              study="false"
              tool="true"
              pathImage={ps}
              name="Photoshop"
              description="Usado para edição de imagens e design gráfico"
            />
            <CardTechnology
              study="false"
              tool="true"
              pathImage={ai}
              name="Ilustrator"
              description="Usado para criação de ilustrações e gráficos vetoriais"
            />
            <CardTechnology
              study="false"
              tool="true"
              pathImage={blender}
              name="Blender"
              description="Ferramenta de modelagem e animação 3D"
            />
          </div>
          <button
            className="btnNavCardTach"
            id="buttonNextCardTech"
            onClick={() => handleScroll("back")}
          >
            <span className="material-symbols-outlined">arrow_forward_ios</span>
          </button>
        </div>
        <img alt="" src={lightRight} className="lightRight"></img>
      </section>
      {/* <section className="sectionPage d-flex-column" id="sectionServices">
        <div className="d-flex-column titleSection sectionAnimate">
          <h1 className="lt-50">Habilidades</h1>
          <small className="paragraph">{textContent[type].subtitleHab}</small>
        </div>
        <div className="containerCardsProjects sectionAnimate">
          <CardServices
            icon="icon1"
            title={textContent[type].habilidades[1].title}
            content={textContent[type].habilidades[1].content}
            path="#"
          />
          <CardServices
            icon="icon0"
            title={textContent[type].habilidades[2].title}
            content={textContent[type].habilidades[2].content}
            path="#"
          />
          <CardServices
            icon="icon3"
            title={textContent[type].habilidades[3].title}
            content={textContent[type].habilidades[3].content}
            path="#"
          />
          <CardServices
            icon="icon2"
            title={textContent[type].habilidades[4].title}
            content={textContent[type].habilidades[4].content}
            path="#"
          />
        </div>
        <img alt="" src={lightLeft} className="lightLeft"></img>
      </section> */}
      <section className="sectionPage d-flex-column" id="sectionProject">
        <div className="d-flex-column titleSection sectionAnimate positionStickyProject">
          <h1 className="lt-50">Projetos</h1>
          <small className="paragraph">
            Aqui estão alguns dos projetos que já desenvolvi
          </small>
        </div>
        <div className="containerProjects">
          {projects.map((project, index) => (
            <CardProject
              key={project.slug}
              slug={project.slug}
              nameProject={project.nameProject}
              description={project.description}
              technologies={project.technologies}
              tag={project.tag}
              thumbLabel={project.thumbLabel}
              featured={index === 0}
            />
          ))}
        </div>
        <img alt="" src={lightRight} className="lightRight lightProject"></img>
      </section>

      <section
        className="sectionPage sectionDepositions d-flex-column"
        id="sectionDepositions"
      >
        <div className="d-flex-column titleSection sectionAnimate">
          <small className="paragraph">Oque dizem sobre mim</small>
          <h1 className="lt-50">Depoimentos</h1>
        </div>

        <div className="bkdFormMakeDepositions">
          <form className="formMakeDepositions">
            <h1 className="lt-50">Dê seu depoimento</h1>
            <div className="containerMakeDepositions">
              <div className="labelInputDefault d-flex-column">
                <label className="paragraph labelForm">Nome</label>
                <input
                  className="inputDefault"
                  type="text"
                  placeholder="Informe seu nome"
                  name="name_user"
                  required
                />
              </div>{" "}
              <div className="labelInputDefault d-flex-column">
                <label className="paragraph labelForm">
                  Empresa ou Instituição
                </label>
                <input
                  className="inputDefault"
                  type="text"
                  placeholder="Informe de onde você me conhece"
                  name="company_deposition"
                  required
                />
              </div>{" "}
              <div className="labelInputDefault d-flex-column">
                <label className="paragraph labelForm">
                  Profissão ou Cargo
                </label>
                <input
                  className="inputDefault"
                  type="text"
                  placeholder="Informe seu cargo ou profissão"
                  name="positio_deposition"
                  required
                />
              </div>{" "}
              <div className="labelInputDefault d-flex-column">
                <label className="paragraph labelForm">Linkedin</label>
                <input
                  className="inputDefault"
                  type="url"
                  placeholder="https://linkedin.com/in/exemplo"
                  name="linkedinDeposition"
                  required
                />
              </div>{" "}
              <div className="labelInputDefault d-flex-column">
                <label className="paragraph labelForm">E-mail</label>
                <input
                  className="inputDefault"
                  type="email"
                  placeholder="Exemplo@email.com"
                  name="user_email"
                  required
                />
              </div>{" "}
              <div className="labelInputDefault d-flex-column">
                <label className="paragraph labelForm">Depoimento</label>
                <textarea
                  className="inputDefault"
                  placeholder="Faça seu depoimento"
                  name="textDeposition"
                  required
                  rows={10}
                ></textarea>
              </div>
              <button className="btn-blue-1 buttonSendDeposition">
                Enviar
              </button>
            </div>
          </form>
        </div>

        <DepositionsCarousel>
          <CardDepositions />
          <CardDepositions />
          <CardDepositions />
          <CardDepositions />
          <CardDepositions />
          <div className="d-flex-column cardDepositions cardDepositions-form">
            <h1 className="titleDepoimented">
              Você me conhece? Deixe seu depoimento!
            </h1>
            <p className="ct-neutral-100 descDepositionMe">
              Se você já trabalhou comigo ou teve alguma experiência relevante
              comigo, compartilhe seu depoimento clicando no botão abaixo. Sua
              opinião é muito importante!
            </p>
            <a
              href="https://forms.gle/DX31prCGrSEk97ZeA"
              target="_blank"
              rel="noreferrer"
              alt="Link para fazer o depoimento"
              className="btn-blue-1 buttonSendNewDeposition"
            >
              Clique aqui
            </a>
          </div>
        </DepositionsCarousel>

        <img alt="" src={lightLeft} className="lightLeft"></img>
      </section>
      <section className="sectionPage sectionContact" id="sectionContact">
        <img
          src={bkgSectionForm}
          className="bkgSectionForm sectionAnimate"
          alt=""
        ></img>
        <div className="boxSectionForm  d-flex-row sectionAnimate">
          <div className="d-flex-column sectionContactText">
            <div className="d-flex-column titleSection titleForm">
              <small className="paragraph hideMobile">
                Não deixe sua ideia para depois! Entre em
              </small>
              <h1 className="lt-50">Contato</h1>
              <small className="paragraph hideMobile">Agora !</small>
            </div>
            <div className="d-flex-column contentContact">
              <p className="paragraph hideMobile">REDES SOCIAIS</p>
              <div className="d-flex-row containerSocial">
                <a
                  href="https://www.linkedin.com/in/luccsll"
                  target="blank"
                  className="buttonSocial"
                >
                  <img alt="" src={linkedin}></img>
                </a>
                <a
                  href="https://www.instagram.com/luccsll"
                  className="buttonSocial"
                >
                  <img alt="" src={instagram}></img>
                </a>
                <a href="https://github.com/luccsll" className="buttonSocial">
                  <img alt="" src={gitHub}></img>
                </a>
              </div>
            </div>
          </div>

          <ContactForm />
        </div>
        <img
          src={lightRight}
          className="lightRight"
          alt="imagem ilustrativa para efeitos"
        ></img>
      </section>
      <footer className="footerNew">
        <span className="f-copy">
          © {new Date().getFullYear()} Lucas Lima · Cuiabá, MT
        </span>
        <div className="f-links">
          <a
            href="https://github.com/luccsll"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <a
            href="https://linkedin.com/in/luccsll"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </footer>
      <a href="#home" className="btnBackToTop">
        Voltar para o topo
        <span className="material-symbols-outlined">arrow_upward</span>
      </a>
    </div>
  );
}

export default App;
